import { Nullable } from '@vy/utils';
import {
  RENEW_CONTRACT_OPTIONS,
  RenewContractOption,
} from '../renew-contract-dialog-types/renew-contract-option';
import { useAutoRenewContractFlow } from './use-auto-renew-contract-flow';
import { RenewContractStepFlowConfig } from '../renew-contract-dialog-types/renew-contract-step-view-config';
import { useRenewContractSameTermsFlow } from './use-renew-contract-same-terms-flow';
import { useRenewContractNewTermsFlow } from './use-renew-contract-new-terms-flow';

export function useContractRenewalFlow(
  selectedOption: Nullable<RenewContractOption>,
  contractId: string,
  isAutoRenewalChecked: boolean,
  handleClose?: () => void,
): RenewContractStepFlowConfig | null {
  const autoRenewFlow = useAutoRenewContractFlow(contractId, isAutoRenewalChecked, handleClose);
  const sameTermsFlow = useRenewContractSameTermsFlow(contractId);
  const newTermsFlow = useRenewContractNewTermsFlow();

  switch (selectedOption) {
    case RENEW_CONTRACT_OPTIONS.Auto:
      return autoRenewFlow;
    case RENEW_CONTRACT_OPTIONS.SameTerms:
      return sameTermsFlow;
    case RENEW_CONTRACT_OPTIONS.NewTerms:
      return newTermsFlow;
    default:
      return null;
  }
}
